// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nESm","content":"styles_content__3Jv8q"};